// // typings
// import { SortingListItem } from 'common/Typings/sorting_typings';

export const MAX_USER_WATCHLIST_COUNT = 10;
export const MAX_UPSTOX_WATCHLIST_COUNT = 5;
export const MIN_WATCHLIST_COUNT = 1;
export const CUSTOM_EXCHANGE_TOKEN_SEPARATOR = '_TOKEN_';
export const ACTIVE_WATCHLIST_ID = 'ACTIVE_WATCHLIST_ID';
export const SAVED_WATCHLIST_SYMBOLS = 'tradingview.savedwatch.';

export enum WatchlistNumberTypes {
  CURATED_LIST = 1,
  SMART_LIST = 2,
  USER_LIST = 3,
}

export const WatchlistTypeToPathMap = {
  [WatchlistNumberTypes.CURATED_LIST]: '/collection',
  [WatchlistNumberTypes.SMART_LIST]: '/smart',
  [WatchlistNumberTypes.USER_LIST]: '/user',
} as const;

export type WatchlistTypeToPathMapValues = valueof<
  typeof WatchlistTypeToPathMap
>;

export const PREVIEW_SCRIPS_AMOUNT = 10;
export const MAX_SCRIPS_AMOUNT = 50;

export const WATCHLIST_ITEM_HEIGHT = 80;
export const ITEM_LIST_TITLE_HEIGHT = 60;
export const EDIT_WATCHLIST_ITEM_HEIGHT = 50;

export const UPDATE_AFTER_CREATE_NOTIFICATION_TIMEOUT = 3500;

export const DEFAULT_WATCHLIST = {
  id: '0',
  title: 'Default watchlist',
  symbols: [],
};

// export const SORT_OPTIONS: SortingListItem[] = [
//   {
//     label: 'CUSTOM',
//     value: 'custom',
//   },
//   {
//     label: 'ALPHABET_AZ',
//     value: 'alphabetAZ',
//   },
//   {
//     label: 'ALPHABET_ZA',
//     value: 'alphabetZA',
//   },
//   {
//     label: 'PRICE_HL',
//     value: 'priceHL',
//   },
//   {
//     label: 'PRICE_LH',
//     value: 'priceLH',
//   },
//   {
//     label: 'PERCENT_HL',
//     value: 'percentHL',
//   },
//   {
//     label: 'PERCENT_LH',
//     value: 'percentLH',
//   },
// ];

// https://upstox.atlassian.net/wiki/spaces/EN/pages/916193320/Watchlist+Service+-+API+Specifications
export enum WatchlistErrorCodes {
  RESOURCE_NOT_FOUND = 6015200,
  INTERNAL_SERVER_ERROR,
  SERVICE_INVALID_RESPONSE,
  INVALID_REQUEST,
  INVALID_INPUT,
  USER_WL_ALREADY_EXIST,
  USER_WL_CANT_EMPTY,
  USER_WL_REPOSITION_FAILED,
  USER_WL_FOLLOW_FAILED,
  USER_WL_FOLLOWED_ALREADY,
  USER_WL_UNFOLLOW_FAILED,
  USER_WL_INSTRUMENT_LIMIT_BREACH = 6041211,
  DISCOVER_TEMPLATE_EMPTY,
  REQUEST_LIMIT_BREACH,
}
